import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  action,
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div
      className={`mb-6 flex flex-col gap-3 md:mb-8 ${
        centered ? "items-center text-center" : "sm:flex-row sm:items-end sm:justify-between"
      }`}
    >
      <div className={centered ? "text-center" : ""}>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-flashlight-fill"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="text-2xl font-extrabold text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className={`mt-2 max-w-2xl text-sm text-foreground-600 md:text-base ${centered ? "mx-auto" : ""}`}>
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}